import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocalizedTimeRangeFormatPipe } from '@wilson/localization';
import { ShiftTimePreferenceSetting } from '@wilson/preferences/core';

@Pipe({
  name: 'shiftTimePreferenceSettingLabel',
  standalone: false,
})
export class ShiftTimePreferenceSettingLabelPipe implements PipeTransform {
  private readonly localizedTimeRangeFormatPipe = inject(
    LocalizedTimeRangeFormatPipe,
  );

  transform(setting: ShiftTimePreferenceSetting): string {
    const range = this.localizedTimeRangeFormatPipe.transform({
      start: new Date(setting.startTime),
      end: new Date(setting.endTime),
    });
    return `${setting.name} | ${range}`;
  }
}
